module.exports = __webpack_public_path__ + "media/03_sekitino_hakoniwa_karatiribame_tobimau_kokutenno_moto_ukasu_hane.e3529bf9.mp3";